// interface related to forms

import { Value } from "react-quill";

// used for registration
export interface IRegistrationForm {
  role: "ca" | "user";
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  password: string;
  confirmPassword: string;
  phoneNumber: string;
  terms_accepted: boolean;
}

// used for login
export interface ILoginForm {
  email: string;
  password: string;
  deviceToken: string; // nullable
}

// used for login with token
export interface ILoginByTokenForm {
  postVerificationToken: string;
}

// used in verify email form
export interface IVerifyEmailForm {
  email: string;
  otp: string;
  preVerificationToken: string;
}

// verify login form
export interface IVerifyLoginForm {
  otp: string;
}

// used  for change password form
export interface IResetPwdForm {
  password: string;
  confirmPassword: string;
}

export interface IForgotPwdForm {
  email: string;
}

// used in google with login
export interface ILoginWithGoogle {
  firebaseIdToken: string;
}

export interface IGeneralSettingForm {
  admin_email: string;
}

export interface ICookiesPolicyForm {
  cookies_policy: string;
}

export interface IPrivacyPolicyForm {
  privacy_policy: string;
}

export interface ITermsServiceForm {
  terms_of_service: string;
}

// used for user profile
export interface IUserProfileForm {
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
}

// used for change password
export interface IChangePasswordForm {
  oldPassword: string;
  newPassword: string;
  confirmNewPassword?: string;
  logOutPreviousSessions: boolean;
}

// interface used in response of the api
// used in login api response
export interface ILoginResponse {
  user: ILoggedInUserRoot;
  authToken: string;
  deviceToken: string;
  isVerified: boolean;
  preVerificationToken: string;
}

// used for login with token
export interface IRegisterResponse {
  preVerificationToken: string;
}

// used verify email response
export interface IVerifyResponse {
  postVerificationToken: string;
}

// used verify email response
export interface ISendOTPResponse {
  preVerificationToken: string;
}

// used for logged in user
export interface ILoggedInUserRoot {
  fullName: string;
  id: number;
  uuid: string;
  role: "admin" | "ca" | "user";
  firstName: string;
  middleName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  emailVerifiedAt: string;
  inactive: boolean;
  lastLoggedInAt: string;
  onboardedAt: string;
  termsAcceptedAt: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  profile: IUserProfile;
  EfilingAuthorizedUsers: any[];
  permissions: string[];
  // groups: string[];
}

export interface IUserProfile {
  fullAddress: string;
  id: number;
  uuid: string;
  phoneNumber: any;
  gender: any;
  dob: any;
  country: any;
  state: any;
  district: any;
  pincode: any;
  address: any;
  bio: any;
  caRegistrationId: any;
  createdAt: string;
  updatedAt: string;
  deletedAt: any;
  userUuid: string;
}

// used in user table filters
export interface IUserFilters {
  q: string;
  orderBy?: string;
  order?: string;
  rowCount: number;
}

// used in filing table filters
export interface IFilingFilters {
  q: string;
  orderBy?: string;
  order?: string;
  rowCount: number;
}

// used in TaxExpertFilters table filters
export interface ITaxExpertFilters {
  q: string;
  orderBy?: string;
  order?: string;
  rowCount: number;
}

// used  for change password form api call
export interface IResetPwdAPI {
  newPassword: string;
  postVerificationToken: string;
}

// used for global settings in store
export type IGlobalSettingsRoot = IGlobalSettings;

export interface IGlobalSettings {
  id: number;
  uuid: number;
  key: string;
  value: string;
  createdAt: string;
  updatedAt: string;
  updatedBy: string;
}

// Define an enum for the variant values
export enum EToastvariant {
  Primary = "primary",
  Secondary = "secondary",
  Success = "success",
  Danger = "danger",
  Warning = "warning",
  Info = "info",
  Light = "light",
  Dark = "dark"
}

export interface IPermissionConfig {
  groups?: Array<any>;
  groupsAnd?: Array<any>;
  permissions?: Array<any>;
  permissionsAnd?: Array<any>;
}

export interface IAppRoutes extends ISBRoute {
  subItems: ISBRoute[];
}

interface ISBRoute {
  groupTitle: string;
  label: string;
  icon: string | any;
  parentLink: string;
  appRouteLink: string;
  permissionConfig: IPermissionConfig | null;
  // allowedTo: Array<IUserRoles>;
  allowedTo: Array<"admin" | "ca" | "user">;
}

export interface IUserForm {
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  role?: string;
  inactive: boolean;
}

// used  for change password form
export interface IUserChangePwdForm {
  newPassword: string;
  confirmNewPassword: string;
}

export interface IUserParams {
  search?: string;
  offset?: number;
  count?: number;
  orderBy?: string | undefined;
  order?: string | undefined; // TODO: fix it to "ASC" or "DESC"
  role?: string;
  inactive?: boolean;
}

export interface IAddEditUser {
  firstName: string;
  middleName: string;
  lastName: string;
  phoneNumber: string;
  inactive: boolean;
  email?: string;
  password?: string;
  role?: string;
}

export interface IUserResponse {
  id: number;
  uuid: string;
  role: string;
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  emailVerifiedAt: string;
  inactive: boolean;
  lastLoggedInAt: string;
  onboardedAt: any;
  termsAcceptedAt: any;
  fullName: string;
  phoneNumber: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: any;
  updatedBy: string;
  profile: IUserProfile;
  totalFilings?: any;
  EfilingAuthorizedUsers?: any[];
}
export interface IAddBlog {
  slug: string|null;
  title: string|null;
  category_name: string|null;
  image_url: File|null;
  content: Value|null;
  created_by?: string|null;
  updated_by?: string|null;
  meta_title?: string|null;
  meta_description?: string|null;
  keywords?: string|null;
  author_profile?: string|null;
  author_bio?: string|null;
  tldr?: string|null;
  read_time?: number;
  faq_items?: {question: string, answer: string}[]|null;
  published_at?: string|null;
  is_featured?: boolean;
  canonical_url?: string|null;
  social_sharing?: boolean;
  show_comments?: boolean;
  show_related?: boolean;
  enable_amp?: boolean;
}
export interface IBlogResponse {
  slug: string;
  title: string;
  category_name: string;
  image_url: string;
  content: string;
  created_by?: string;
  updated_by?: string;
  meta_title?: string;
  meta_description?: string;
  keywords?: string;
  author_profile?: string;
  author_bio?: string;
  tldr?: string;
  read_time?: number;
  faq_items?: {question: string, answer: string}[];
  published_at?: string;
  is_featured?: boolean;
  canonical_url?: string;
  social_sharing?: boolean;
  show_comments?: boolean;
  show_related?: boolean;
  enable_amp?: boolean;
  created_at?: string;
  updated_at?: string;
  views_count?: number;
  likes_count?: number;
  comments_count?: number;
  shares_count?: number;
}
export interface IBlogStats {
  total_blogs: number;
  total_views: number;
  total_comments: number;
  total_likes: number;
  total_shares: number;
  top_blogs: {
    slug: string;
    title: string;
    views: number;
  }[];
  recent_comments: {
    blog_slug: string;
    blog_title: string;
    comment: string;
    author: string;
    date: string;
  }[];
  engagement_rate: number;
  average_read_time: number;
  category_distribution: {
    category: string;
    count: number;
  }[];
}
export interface IBlogComment {
  id: string;
  blog_slug: string;
  author_name: string;
  author_email: string;
  content: string;
  parent_id?: string;
  created_at: string;
  updated_at?: string;
  likes_count: number;
  is_approved: boolean;
}
export interface IBlogParams {
  search?: string;
  offset?: number;
  count?: number;
  orderBy?: string | undefined;
  order?: string | undefined;
  category?: string;
  featured?: boolean;
}
export interface ITaxExpertForm {
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  inactive: boolean;
  password: string;
  confirmPassword: string;
}

export interface IAFPlanForm {
  published: string;
  featured: boolean;
  title: string;
  subTitle: string;
  pricingValue: string;
  pricingSubTitle: string;
  description: string;
  incomeSources: any[];
  footerContent: string;
}

export interface IPricingRule {
  minFilesCompleted: string | number;
  pricePerFile: string;
}

export interface ISFPlanForm {
  uUId: string;
  published: string;
  featured: boolean;
  title: string;
  subTitle: string;
  pricingValue: string;
  pricingSubTitle: string;
  description: string;
  footerContent: string;
  pricingRule: IPricingRule[];
}

export interface IPlanParams {
  search?: string;
  offset?: number;
  count?: number;
  orderBy?: string | undefined;
  order?: string | undefined; // TODO: fix it to "ASC" or "DESC"
  type?: string;
}

export interface IPlanAddEdit {
  pricingRule: IPricingRule[];
  incomeSources: IIncomeSource[];
  title: string;
  subTitle: string;
  pricingTitle: string;
  pricingSubTitle: string;
  description: string;
  footerContent: string;
  featured: boolean;
  published: any;
  type?: string;
}
export interface IPlansRoot {
  pricingRule: IPricingRule[];
  incomeSources: IIncomeSource[];
  id: number;
  uuid: string;
  title: string;
  subTitle: string;
  pricingTitle: string;
  pricingSubTitle: string;
  slug: string;
  type: string;
  description: string;
  footerContent: string;
  featured: boolean;
  inactive: boolean;
  publishedAt: any;
  createdAt: string;
  updatedAt: string;
  deletedAt: any;
  updatedBy: any;
  isDisabledPlan: boolean;
}

export interface IIncomeSource {
  id: string;
  value: string;
}

export interface IPricingPageSettingsForm {
  pricingTitle: string;
  pricingSubTitle: string;
  footerContent: string;
  pricingTitleUuId: string;
  pricingSubTitleUuId: string;
  footerContentUuId: string;
}

export interface IDeductUndChapVIA {
  // Section80CCD1B: number;
  Section80C: number;
  Section80CCC: number;
  Section80CCDEmployeeOrSE: number;
  Section80CCDEmployer: number;
  Section80CCE: number;
  Section80CCF: number;
  Section80CCG: number;
  Section80CCH: number;
  Section80D: number;
  Section80DD: number;
  Section80DDB: number;
  Section80E: number;
  Section80EE: number;
  Section80EEA: number;
  Section80EEB: number;
  Section80G: number;
  Section80GG: number;
  Section80GGA: number;
  Section80GGB: number;
  Section80GGC: number;
  Section80IA: number;
  Section80IB: number;
  Section80IC: number;
  Section80JJA: number;
  Section80JJAA: number;
  Section80LA: number;
  Section80M: number;
  Section80P: number;
  Section80QQB: number;
  Section80RRB: number;
  Section80TTA: number;
  Section80TTB: number;
  Section80U: number;
}

// ITR 1 related form intrface
export interface IFormITR1 {
  FirstName: string;
  MiddleName: string;
  SurNameOrOrgName: string;
  DOB: string;
  DOCommencement: string;
  FatherName: string;
  Gender: string;
  MaritalStatus: string;
  Status: string;
  AadhaarCardNo: string;
  AadhaarEnrolmentId: string;
  PAN: string;
  CountryCodeMobile: string;
  MobileNo: string;
  EmailAddress: string;
  CountryCodeMobileNoSec: string;
  MobileNoSec: string;
  EmailAddressSec: string;
  STDCodeLandlineNumber: string;
  LandlineNumber: string;
  Address: {
    ResidenceNo: string;
    ResidenceName: string;
    RoadOrStreet: string;
    LocalityOrArea: string;
    CityOrTownOrDistrict: string;
    ZipCode: string;
    PinCode: string;
    CountryCode: string;
    StateCode: string;
    ResidentialStatus: string;
  };
  NRIStayInIndia1: string;
  NRIStayInIndia2: string;
  NRIJurisdictionDetails: string[][];
  AddtnlBankDetails: IBankAccount[];
  FilingReturnInfo: {
    FormName: "ITR-1" | "ITR-2" | "ITR-3" | "ITR-4";
    RegimeType: string;
    Filed: string;
    FiledNotice: string;
    FiledToggle: boolean | undefined;
    FiledNoticeToggle: boolean | undefined;
  };
  IncomeDetails: {
    Salaries: IAddIncomeForm[];
    // Any Other Income Sources
    InterestIncomes: IInterestIncomes | null;
    DividendIncomes: IDividendIncome | null;
    AgriculturalIncomes: IAgriculturalIncomes | null;
    ExemptIncomes: IExemptIncomes | null;
    OtherIncomes: IOtherIncomes | null;
    VirtualDigitalAssets: IVirtualDigitalAssets[];
    ForeignShares: IForeignSharesForm[];
    Stocks: IStocksForm[];
    MutualFunds: IMutualFundForm[];
    SaleLandAndBuildings: ISaleLandAndBuildingForm[];
    StockOptionsRSUs: IStockOptionsRSUsForm[];
    OtherAssets: IAnyOtherAssets[];
    RISelfOccupiedProperties: ISelfOccupiedProperties[];
    RIGivenOnRentProperties: IGivenOnRentProperties[];
    ProfessionalIncomes: IProfessionalIncomes | null;
    BusinessIncomes: IBusinessIncomes | null;
    FinancialParticulars: IFinancialParticulars | null;
    DeemedCapitalGains: IDeemedCapitalGains | null;
    BondsAndDebenture: IBondsDebentureForm[];
  };
  CommonDeductions: ICommonDeductions;
  DonationsEduHRADeductions: IDonationsEduHRADeductions;
  OtherDeductions: IOtherDeductions;
  TaxesPaidTDSandTCS: {
    NonSalaryTDS: INonSalaryTDS[];
    ImmovableProperties: IImmovableProperties[];
    TaxesCollectedAtSources: ITaxesCollectedAtSources[];
    SelfTaxPayments: ISelfTaxPayments[];
    CarryForwardLosses: ICarryForwardLosses;
  };
  TotalTDSonSalaries: number; // TDS on Salary
  TotalTDSonOthThanSals: number; // NonSalaryTDS
  TotalTDS3Details: number; // ImmovableProperties
  TotalSchTCS: number; // TaxesCollectedAtSources
  TotalSelfTaxPayments: number; // SelfTaxPayments (TotalTaxPayments for mapping)
  TaxPaidBefore15June: number; // Sum of advance tax paid before 15 June
  TaxPaidBefore15Sept: number; // Sum of advance tax paid before 15 Sept
  TaxPaidBefore15Dec: number; // Sum of advance tax paid before 15 Dec
  TaxPaidBefore15Mar: number; // Sum of advance tax paid before 15 Mar
  DeductUndChapVIA: IDeductUndChapVIA; // DeductUndChapVIA will be used for mapping
  TempDeductUndChapVIA: IDeductUndChapVIA; // TempDeductUndChapVIA will be used when switching regime from new to old and old to new
  TotalChapVIADeductions: number; // actual total of deductions, used for calculation
  GrossSalary: number;
  Salary: number;
  PerquisitesValue: number;
  ProfitsInSalary: number;
  NetSalary: number;
  DeductionUs16: number;
  DeductionUs16ia: number;
  EntertainmentAlw16ii: number;
  ProfessionalTaxUs16iii: number;
  TotalReliefUs89: number;
  TotalIncClaimedForReliefUs89A: number;
  IncomeFromSal: number;
  GrossRentReceived: number;
  TaxPaidlocalAuth: number;
  AnnualValue: number;
  StandardDeduction: number;
  InterestPayable: number;
  ArrearsUnrealizedRentRcvd: number;
  TotalIncomeOfHP: number;
  OthersInc: IReviewOSIncomes; // total of children in other sources
  IncomeOthSrc: number; // total of other sources
  GrossTotIncome: number;
  TotalIncome: number;
  BusOrProfIncomes: {
    PISection44ADA: number;
    BISection44AD: number;
    TotalLiabilities: number;
    TotalAssets: number;
  };
  TotalBusOrProfIncome: number;
  CapitalGains: {
    TotalStocksGain: number;
    TotalMutualFundsGain: number;
    TotalForeignSharesGain: number;
    TotalLandBuildingGain: number;
    TotalStockOptionsRSUsGain: number;
    TotalBondsDebentureGain: number;
    TotalDeemedCapitalGain: number;
    TotalAnyOtherAssetsGain: number;
  };
  TotalCapitalGains: number;
  CapitalGainsSplRateTax: {
    StocksSplRateTax: number;
    MutualFndSplRateTax: number;
    LandSplRateTax: number;
  };
  CapitalGainsNrlRateIncome: {
    StocksNrlRateIncome: number;
    MutualFndNrlRateIncome: number;
    LandNrlRateIncome: number;
  };
  TotalSplRateTax: number;
  TotalNrlRateIncome: number;
  HousePropertyIncomes: {
    TotalSelfOccupied: number;
    TotalOnRent: number;
  };
  TotalHousePropertyIncome: number;
  VirtualDigitalAssets: {
    TotalCryptoIncome: number;
  };
  TotalVirtualDigitalAsset: number;
  TaxPaid: {
    TaxesPaid: {
      AdvanceTax: number; // sum TotalSelfTaxPayments (TotalTaxPayments)
      TDS: number; // sum of TotalTDSonSalaries, TotalTDSonOthThanSals, TotalTDS3Details
      TCS: number; // sum of TotalSchTCS
      SelfAssessmentTax: number;
      TotalTaxesPaid: number; // sum of above values
    };
    BalTaxPayable: number;
  };
  TotalTaxableIncome: number;
  ITR1_TaxComputation: {
    IntrstPay: {
      IntrstPayUs234A: number;
      IntrstPayUs234B: number;
      IntrstPayUs234C: number;
      LateFilingFee234F: number;
    };
    TotalTaxPayable: number; // cal tax to pay
    Rebate87A: number; // tax amount applicable in rebate (same as TotalTaxPayable)
    TaxPayableOnRebate: number; // actual tax value, tax after rebate (rebate apply then 0 otherwise TotalTaxPayable)
    Surcharge: number;
    EducationCess: number;
    GrossTaxLiability: number;
    Section89: number;
    NetTaxLiability: number;
    TotalIntrstPay: number;
    TotTaxPlusIntrstPay: number;
  };
  // will be used to change the ITR form values state to run auto save
  // (needed when saving data from offcanvas form submit)
  LastSavedTimeStamp: number;
}

export interface ISelfOccupiedProperties {
  PropertyType: string;
  IsSameAddress: boolean;
  Address: {
    ResidenceNo: string;
    ResidenceName: string;
    RoadOrStreet: string;
    LocalityOrArea: string;
    CityOrTownOrDistrict: string;
    ZipCode: string;
    PinCode: string;
    CountryCode: string;
    StateCode: string;
    ResidentialStatus: string;
  };
  OwnerDetails: IHPOwnerDetailsForm[];
  TotalAnnualRentReceived: string;
  MunicipalTax: string;
  NetIncome: string;
  StandardDeductionUs24A: string;
  FinancialYear: string;
  InterestPreConstruction: string;
  InterestPostConstruction: string;
  TotalDeduction: string;
  NetTaxableIncome: string;
}

export interface IGivenOnRentProperties {
  PropertyType: string;
  IsSameAddress: boolean;
  Address: {
    ResidenceNo: string;
    ResidenceName: string;
    RoadOrStreet: string;
    LocalityOrArea: string;
    CityOrTownOrDistrict: string;
    ZipCode: string;
    PinCode: string;
    CountryCode: string;
    StateCode: string;
    ResidentialStatus: string;
  };
  OwnerDetails: IHPOwnerDetailsForm[];
  TenantDetails: IGivenOnRentTenantDetailsForm[];
  TotalAnnualRentReceived: string;
  MunicipalTax: string;
  NetIncome: string;
  StandardDeductionUs24A: string;
  FinancialYear: string;
  InterestPreConstruction: string;
  InterestPostConstruction: string;
  TotalDeduction: string;
  NetTaxableIncome: string;
}

export interface IHPOwnerDetailsForm {
  FullName: string;
  Percentage: string;
  Pan: string;
}
export interface IGivenOnRentTenantDetailsForm {
  TenantName: string;
  Aadhaar: string;
  Pan: string;
}

export interface IRentOwner {
  FullName: string;
  PAN: string;
  Share: string;
}

export interface IRentTenant {
  FullName: string;
  PANorTAN: string;
  AadhaarCardNo: string;
}

export interface ICarryForwardLosses {
  PreviousYearsLosses: string[][];
  DepreciationLosses: string[][];
  FilingAndDueDates: string[][];
}

export interface IResidentialQuestion {
  id: number;
  question: string;
  type: string;
  answers: IResidentialQsnResponse[];
  instructions: any;
}

export interface IResidentialQsnResponse {
  label: string;
  value: number | null; // point to next question id
  residentialStatus?: string;
}

export interface ISelectedQueResp {
  questionId: number;
  selectedAnswer: IResidentialQsnResponse;
  selectedValue: any;
}

export interface ISelfTaxPayments {
  Amount: string;
  ChallanNo: string;
  DepositDate: string;
  BSRCode: string;
}

export interface ITaxesCollectedAtSources {
  CollectorTAN: string;
  CollectorName: string;
  TotalTaxCollected: string;
  ClaimOrTransferTDSCredits: boolean;
  TDSCreditRelatingTo: string;
  TDSCreditAmount: string;
  PANOfOtherPerson: string;
  TaxCollectedClaimedForThisYear: string;
  ExpenditureAgainstTDS: string;
  FinancialYearTDSCollected: string;
}

export interface IImmovableProperties {
  BuyerPAN: string;
  BuyerName: string;
  TotalTaxDeducted: string;
  ClaimOrTransferTDSCredits: boolean;
  TDSCreditRelatingTo: string;
  TDSCreditAmount: string;
  PANOfOtherPerson: string;
  IncomeRelatingToTDSCredit: string;
  TaxDeductedClaimedForThisYear: string;
  IncomeAgainstTDS: string;
  TypeOfIncome: string;
  FinancialYearTDSDeducted: string;
}

export interface INonSalaryTDS {
  DeductorTAN: string;
  DeductorName: string;
  TotalTaxDeducted: string;
  ClaimOrTransferTDSCredits: boolean;
  TDSCreditRelatingTo: string;
  TDSCreditAmount: string;
  PANOfOtherPerson: string;
  IncomeRelatingToTDSCredit: string;
  TaxDeductedClaimedForThisYear: string;
  IncomeAgainstTDS: string;
  TypeOfIncome: string;
  FinancialYearTDSDeducted: string;
}

export interface IOtherDeductions {
  DependentDisabled80DD: { Nature: string; Relation: string };
  TotalSection80DD: string;
  SelfDisabilitySection80U: string;
  TotalSection80U: string;
  TotalSection80EE: string;
  TotalSection80EEA: string;
  TotalSection80EEB: string;
  TotalSection80QQB: string;
  TotalSection80RRB: string;
  TotalSection80GGC: string;
  TotalSection80JJA: string;
  AgeOfPerson80DDB: string;
  TotalSection80DDB: string;
  TotalSection80CCH: string;
}

export interface IDonationsEduHRADeductions {
  TotalSection80E: string;
  TotalSection80GG: string;
  S80GGPaidRentMonths: string;
  Section80GDonationDetails: ISection80GDonation[];
  Section80GGADonationDetails: ISection80GGADonation[];
}

export interface ISection80GGADonation {
  DonationCause: string;
  DoneePAN: string;
  DoneeName: string;
  FullAddress: string;
  PinCode: string;
  ZipCode: string;
  CountryCode: string;
  StateCode: string;
  CityOrTownOrDistrict: string;
  CashDonation: string;
  NonCashDonation: string;
  TotalDonation: number;
}

export interface ISection80GDonation {
  OrganizationName: string;
  DoneePAN: string;
  DoneeName: string;
  FullAddress: string;
  PinCode: string;
  ZipCode: string;
  CountryCode: string;
  StateCode: string;
  CityOrTownOrDistrict: string;
  DeductionLimit: string;
  QualifyingPercentage: string;
  CashDonation: string;
  NonCashDonation: string;
  TotalDonation: number;
}

export interface ICommonDeductions {
  ParentsAgeGroup: string;
  HaveMedicalInsurance: boolean;
  ICDMedical80D: ICDMedical80D | null;
  HavePreventiveHealthCheck: boolean;
  PreventiveHealthSelfAndFamily: string;
  PreventiveHealthParent: string;
  MedicalExpendituresSelfAndFamily: string;
  MedicalExpendituresParent: string;
  TotalSection80C: string;
  TotalSection80TTA: string;
  TotalSection80CCC: string;
  TotalSection80CCD1Employee: string;
  TotalSection80CCD2Employer: string;
}

export interface ICDMedical80D {
  SelfAndFamilySeniorCitizen: boolean;
  ParentSeniorCitizen: boolean;
  ForSelfAndFamily: boolean;
  ForParents: boolean;
  SelfAndFamilyMedicalInsurance: string;
  SelfAndFamilyHealthCheckup: string;
  SelfAndFamilyMedicalExpenditure: string;
  ParentsMedicalInsurance: string;
  ParentsHealthCheckup: string;
  ParentsMedicalExpenditure: string;
  TotalSection80D: string;
  TotalHealthCheckup: string;
  TotalExpenditure: string;
}

export interface IInterestIncomes {
  SavingBankIncomes: string[][];
  DepositIncomes: string[][];
  P2PInvestments: string[][];
  BondInvestments: string[][];
  PFIncomes: string[][];
  IncomeTaxRefundInterestAmt: string[][];
  OtherInterestIncomes: string[][];
}

export interface IAgriculturalIncomes {
  GrossAgricultureReceipt: string;
  ExpenditureOnAgriculture: string;
  UnabsorbedAgricultureLoss: string;
  AgricultureLandDetails: IAgrLandDetails[];
  AgrNetIncome: number;
}

export interface IAgrLandDetails {
  DistrictName: string;
  Pincode: string;
  Measurement: string;
  OwnershipStatus: string;
  WaterSource: string;
}

export interface IExemptIncomes {
  InterestPPFIncomes: string[][];
  InterestNREIncomes: string[][];
  OtherExemptIncomes: string[][];
}

export interface IDividendIncome {
  // DomesticCompanyIncomes: Array<{ Narration: string; ReceiptDate: string; Amount: string }>;
  DomesticCompanyIncomes: string[][];
  // MutualFundsIncomes: Array<{ Narration: string; ReceiptDate: string; Amount: string }>;
  MutualFundsIncomes: string[][];
}

export interface IOtherIncomes {
  // AnyOnlineGaming: Array<{ Source: string; Description: string; Amount: string }>;
  AnyOnlineGaming: string[][];
  // AnyInvoiceDiscounting: Array<{ Name of Platform: string; Amount: string }>;
  AnyInvoiceDiscounting: string[][];
  // AnyOtherIncomes: Array<{ Source: string; Description: string; Amount: string }>;
  AnyOtherIncomes: string[][];
  // DepreciationSection57Incomes: Array<{ Source: string; Amount: string }>;
  DepreciationSection57Incomes: string[][];
  // UnderSection89AIncomes: Array<{ Country: string; TimePeriod: string; Amount: string }>;
  UnderSection89AIncomes: string[][];
  TaxationRelief89AAmount: string;
  IncomeNonNotifiedCountryAmount: string;
  IncomeTaxablePreviousYear89A: string;
}

export interface IVirtualDigitalAssets {
  NFTAssetName: string;
  PurchaseDate: string;
  SaleDate: string;
  TotalPurchasePrice: string;
  TotalSalePrice: string;
  Gains: string;
}

export interface ICapitalGains {
  CapitalGainsType: string;
  NFTAssetName: string;
  PurchaseDate: string;
  SaleDate: string;
  TotalPurchasePrice: string;
  TotalSalePrice: string;
  Gains: string;
}

export interface IForeignSharesForm {
  TypeAssets: string;
  SaleDate: string;
  PurchaseDate: string;
  DescriptionAssetSold: string;
  TotalSalePrice: string;
  TotalPurchasePrice: string;
  TransferExpense: string;
  Gains: string;
}

export interface IBondsDebentureForm {
  TypeBonds: string;
  SaleDate: string;
  PurchaseDate: string;
  DescriptionAssetSold: string;
  TotalSalePrice: string;
  TotalPurchasePrice: string;
  TransferExpense: string;
  Gains: string;
}

export interface IStocksForm {
  TypeAssets: string;
  Acquisition: string;
  STTPaid: string;
  ISINCode: string;
  NameOfShare: string;
  SalePrice: string;
  TransferExpense: string;
  TotalSaleConsideration: string;
  TotalCostAcquisition: string;
  TotalFairMarketValue: string;
  CapitalGains: string;
}

export interface IStocksExtractForm {
  long_term: IStocksForm;
  short_term: IStocksForm;
}

export interface IMutualFundForm {
  TypeAssets: string;
  STTPaid: string;
  DescriptionAssetSold: string;
  NetSalePrice: string;
  TransferExpense: string;
  TotalSalePrice: string;
  TotalFairMarketValue: string;
  TotalPurchasePrice: string;
  CapitalGains: string;
}

export interface IDeemedCapitalGains {
  loTermCapitalGains: boolean;
  loDeemedTotalAmount: string;
  loUnutilizedCapitalGains: string;
  loOtherDeemedAmount: string;
  shTermCapitalGains: boolean;
  shDeemedTotalAmount: string;
  shUnutilizedCapitalGains: string;
  shOtherDeemedAmount: string;
}

export interface IStockOptionsRSUsForm {
  TypeOfStock: string;
  SaleDate: string;
  ExerciseDate: string;
  DescriptionOfSale: string;
  TotalSalePrice: string;
  TransferPrice: string;
  ExerciseValue: string;
  PaySTT: string;
  FairMarketValue: string;
  DescriptionAssetSold: string;
  Gains: string;
}

export interface ISaleLandAndBuildingForm {
  SaleDate: string;
  PurchaseDate: string;
  DescriptionAssetSold: string;
  TotalSalePrice: string;
  StampDuty: string;
  SaleConsideration: string;
  TotalPurchasePrice: string;
  CostImprovementDetails: string;
  TransferExpense: string;
  Balance: string;
  Deduction: string;
  CapitalGains: string;
  PropertyAddress: string;
  PinCode: string;
  AddressLine: string;
  CountryCode: string;
  StateCode: string;
  CityOrTownOrDistrict: string;
  BuyerDetails: ISLBuyerDetailsForm[];
  SplRateTax: number;
  NrlRateIncome: number;
}

export interface ISLBuyerDetailsForm {
  BuyerName: string;
  Aadhaar: string;
  Pan: string;
  Amount: string;
  Percentage: string;
}

export interface IAnyOtherAssets {
  Description: string;
  PurchaseDate: string;
  SaleDate: string;
  TotalPurchasePrice: string;
  TotalSalePrice: string;
  TransferExpense: string;
  AddCostOfImprovementExpanses: boolean;
  ImprovementExpenses: string[][];
}

// other assets professional income
export interface IProfessionalIncomes {
  BusinessName: string;
  Description: string;
  BusinessCode: string;
  OtherMode: string;
  InCash: string;
  ElectronicMode: string;
  GrossReceipt: string;
  TotalSection44ADA: string;
}

// other assets business income
export interface IBusinessIncomes {
  BusinessName: string;
  Description: string;
  BusinessCode: string;
  OtherMode: string;
  InCash: string;
  ElectronicMode: string;
  GrossTurnover: string;
  Total: string;
  SixPerElectronicMode: string;
  EightPerIncashOthermode: string;
}

export interface IFinancialParticulars {
  UnsettledPayables: string;
  OutstandingSecuredLoans: string;
  OutstandingUnsecuresLoans: string;
  Advances: string;
  CapitalInvestments: string;
  OtherLiabilities: string;
  TotalLiabilities: string;
  UncollectedReceivables: string;
  TotalInventoryValue: string;
  CashInHand: string;
  FixedAssets: string;
  ClosingBalance: string;
  LoansAndAdvances: string;
  OtherAssets: string;
  TotalAssets: string;
}

export interface IAddIncomeForm {
  EmployerName: string;
  EmployerCategory: string;
  EmployerTAN: string;
  TotalTDSSal: string;
  EmployerAddress: string;
  PinCode: string;
  ZipCode: string;
  CountryCode: string;
  StateCode: string;
  CityOrTownOrDistrict: string;
  GrossSalary: string;
  NetSalary: string;
  SalaryTotalDeductions: string;
  SalaryIncomeChargeable: string;
  "SalaryAsPerSection17_1": string;
  // added in SalaryOtherAllowances array
  // "BasicPay": string;
  // "HouseRentAllowance": string;
  // "LTAAllowance": string;
  // added in SalaryOtherAllowances array
  "SalaryOtherAllowances": string[][];
  "PerquisitesUnderSection17_2": string;
  "PerquisitesDescriptions": string[][];
  "ProfitsInLieuOfSalaryUnderSection17_3": string;
  "ProfitsInLieuDescriptions": string[][];
  "IncomeUnderSection89ANotifiedCountry": string;
  "IncomeUnderSection89ADescriptions": string[][];
  "IncomeUnderSection89AOtherThanNotifiedCountry": string;
  "IncomeTaxableDuringThePreviousYear89A": string;
  "ExemptAllowancesUnderSection10": string;
  // added in ExemptAllowancesDescriptions array
  // "ExemptAllowancesHouseRentExemption": string;
  // "ExemptAllowancesLTAExemption": string;
  // added in ExemptAllowancesDescriptions array
  "ExemptAllowancesDescriptions": string[][];
  "StandardDeductions16ia": string;
  "EntertainmentAllowance16ii": string;
  "ProfessionalTaxUnderSection16iii": string;
  "ReliefUnderSection89": string;
  "IncomeClaimedForReliefUnderSection89A": string;
}

export interface IBankAccount {
  UseForRefund: string;
  IFSCCode: string;
  BankName: string;
  BankAccountNo: string;
  BankAccountType: string;
}

// for review details

export interface ReviewOtherIncomes extends IInterestIncomes {}
export interface IReviewOSIncomes {
  "TotalInterestIncome": number;
  "TotalDividendIncome": number;
  "TotalAgriculturalIncome": number;
  "TotalExemptIncome": number;
  "TotalOtherIncome": number;
}

// used in review tab for capital gains income
export interface IReviewCapitalGains {
  "TotalStocksGain": number;
  "TotalMutualFundsGain": number;
  "TotalForeignSharesGain": number;
  "TotalLandBuildingGain": number;
  "TotalStockOptionsRSUsGain": number;
  "TotalBondsDebentureGain": number;
  "TotalDeemedCapitalGain": number;
  "TotalAnyOtherAssetsGain": number;
}

// used in review tab for Virtual Digital Assets (VDA) income
export interface IReviewVDAGains {
  "TotalCryptoIncome": number;
}

// used in review tab for House Property Income income
export interface IReviewHPGains {
  "TotalSelfOccupied": number;
  "TotalOnRent": number;
}

// used in review tab for Taxes Paid in Tax Accordion
export interface IReviewTaxesPaid {
  "TotalTDSonSalary": number;
  "TotalNonSalaryTDS": number;
  "TotalTDSonSaleOrRent": number;
  "TotalTaxesAtSource": number;
  "TotalSelfTaxPayments": number;
}

export interface IReviewITR1 {
  "FirstName": string;
  "MiddleName": string;
  "SurNameOrOrgName": string;
  "FullName": string;
  "DOB": string;
  "PAN": string;
  "ResidentialStatus": string;
  "RegimeType": string;
  "SalarySummaries": IReviewIncome[];
  "TotalNetSalary": number;
  "TotalStdDedUs16i": number;
  "TotalEntUs16ii": number;
  "TotalProfUs16iii": number;
  "TotalReliefUs89": number;
  "TotalClaimedReliefUs89A": number;
  "TotalIncomeFromSalaries": number;
  "OtherSourcesIncomes": IReviewOSIncomes;
  "TotalOtherSourcesIncome": number;
  "BusinessOrProfessionIncomes": {
    "PISection44ADA": number;
    "BISection44AD": number;
    "TotalLiabilities": number;
    "TotalAssets": number;
  };
  "TotalBusinessOrProfessionIncome": number;
  "CapitalGains": IReviewCapitalGains;
  "TotalCapitalGainsIncome": number;
  "VDAIncomes": IReviewVDAGains;
  "TotalVDAIncome": number;
  "HousePropertyIncomes": IReviewHPGains;
  "TotalHousePropertyIncome": number;
  "GrossTotalIncome": number;
  "TotalTaxableIncome": number;
  "DeductionSummaries": {
    [key: string]: {
      "DeductionSection": string;
      "Amount": number;
    };
  };
  "TotalDeductions": number;
  "AllTaxesPaid": IReviewTaxesPaid;
  "TotalTaxPaidTDS": number;
  "TaxPayable": number; // Total Tax: (tax + taxCess)
  "TaxDetails": {
    "Tax": number; // Income Tax at normal rates
    "TaxCess": number; // Health and Education Cess
  };
  "InterestDetails": {
    "Interest234A": number;
    "Interest234B": number;
    "Interest234C": number;
    "Fee234F": number;
  };
  "InterestPayable": number; // Total Interest Due:
  "TotalTaxPayable": number; // ((TaxPayable)Total Tax + (InterestPayable)Total Interest Due)
  "TaxDue": number; // Taxes Due or Refund (Tax Paid - Tax Payable)
  "TaxRefund": number; //Taxes Due or Refund (Tax Paid - Tax Payable)
  "TaxesDueOrRefund": number;

  "ItrOption": string;
  "WhichItr": string;
  "TaxableIncomeFromSalary": string;
  "DeductionUs16": string;
  "StdDeduction": string;
  "EntertainmentAllowance": string;
  "TaxOnEmployment": string;
  "TaxableIncomeFromHouseProperty": string;
  "ExpenseUs57": string;
  "TaxableIncomeFromOtherSources": string;
  "ShortTermSlab": string;
  "ShortTermSpecial": string;
  "LongTermTen": string;
  "LongTermTwenty": string;
  "CapGainTotal": string;
  "PresumptiveBusinessIncome": string;
  "PresumptiveGoodsCarriageIncome": string;
  "PresumptiveProfessionIncome": string;
  "RegularBusinessAccountMaintained": string;
  "RegularBusinessAccountNotMaintained": string;
  "SpeculativeIncome": string;
  "RemunerationFromPartnershipsFirms": string;
  "TotalTaxableIncomeFromVda": string;
  "TaxableIncomeFromVdaCg": string;
  "TaxableIncomeFromVdaBi": string;
  "TaxCreditUS87A": string;
  "IsCred87AApplicable": boolean;
  "TaxAtNormalRates": string;
  "TaxAt10Percent": string;
  "TaxAt15Percent": string;
  "TaxAt20Percent": string;
  "HealthEducationCess": string;
  "AgriRelief": string;
  "TotalTax": string;
  "BasicExemption": string;
  "IsTdsPaid": boolean;
  "TdsPaid": string;
  "IsTcsPaid": boolean;
  "TcsPaid": string;
  "IsSelfAssTaxPaid": boolean;
  "SelfAssessmentTaxPaid": string;
  "IsAdvanceTaxPaid": boolean;
  "AdvanceTaxPaid": string;
  "TaxPaid": string;
  "TaxPaymentLink": "https://eportal.incometax.gov.in/iec/foservices/#/e-pay-tax-prelogin/user-details";
  "IsGlobalValidationSuccess": boolean;
  "IsNewRegimeBelatedOriginalReturn": boolean;
  "IsFilingAllowedWhenPartnerIsLiableForAudit": boolean;
}

// used in review for income salary
export interface IReviewIncome {
  "EmployerName": string;
  "NetSalary": string;
  "TotalExemptUs10": string;
  "SalaryTotalDeductions": string;
  "ReliefUs89": string;
  "ClaimedReliefUs89A": string;
  "TotalGrossSalary": string;
  "SalaryIncomeChargeable": string;
}

// used in chartData
export interface IChartData {
  name: string;
  NewRegimeValue: number;
  OldRegimeValue: number;
}

export interface ICRTableData {
  GrossTotIncome: number;
  newRegimeDeductions: number;
  oldRegimeDeductions: number;
  newRegimePayable: number;
  oldRegimePayable: number;
  newTaxableIncome: number;
  oldTaxableIncome: number;
  newBalTaxPayable: number;
  oldBalTaxPayable: number;
  newTotalTaxPaid: number;
  oldTotalTaxPaid: number;
}

// single ITR filing response

export interface IFilingResponse {
  id: number;
  pan: string;
  name: string;
  fileUsedBy: string;
  assessmentYear: string;
  uuid: string;
  efilingData: IFormITR1;
  completedAt: string;
  canceledAt: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  userUuid: string;
  updatedBy: string;
  efilingPlan: IEfilingPlan;
  efilingDocuments: any[];
  efilingAuthorizedUser: IAssignedExpert;
  efilingCreatedBy: { fullName: string; email: string; phoneNumber: string };
  efilingUpdatedBy: { fullName: string };
  status: string;
}

export interface IEfilingDetailsData {
  name: string;
  pan: string;
  fileUsedBy: string;
  EfilingData: IFilingResponse[];
}

export interface IAssignFiling {
  assign_to: string;
  assignedToData?: any;
}

export interface IAssignedExpert {
  id: number;
  uuid: string;
  createdAt: string;
  updatedAt: string;
  userUuid: string;
  efilingUuid: string;
  User: { fullName: string };
}

// Define an enum for action on any thing with the given name
export enum EActionItem {
  NULL = "",
  TOGGLE_STATUS = "toggle-status",
  DELETE = "delete",
  DELETE_AF_PLAN = "delete-af-plan",
  ASSIGN = "assign",
  CREATE = "create",
  PAYMENT = "payment"
}

// miscellaneous

export type IActiveTabs = "personal-details" | "income-details" | "deductions" | "review-file";

export type IActiveMDTTabs = "messages" | "documents" | "transaction" | undefined;

export type IApiState = "PENDING" | "FULFILLED" | "REJECTED";

export type ITaxExpertTabs = "profile" | "self" | "assisted" | "change-password";

export type ISalaryFormTypes = "MANUAL" | "UPLOAD" | null;

export type IStocksFormTypes = "MANUAL" | "UPLOAD" | null;

export type IMutualFundFormTypes = "MANUAL" | "UPLOAD" | null;

export type IUserRoles = "admin" | "ca" | "user";

export interface IPostOfficeRes {
  Message: string;
  Status: string;
  PostOffice: IPostOffice[];
}

export interface IPostOffice {
  Name: string;
  Description: any;
  BranchType: string;
  DeliveryStatus: string;
  Circle: string;
  District: string;
  Division: string;
  Region: string;
  Block: string;
  State: string;
  Country: string;
  Pincode: string;
}

export type PincodeData = { CountryCode: string; StateCode: string; CityOrTownOrDistrict: string };

export interface IDocUploadSection {
  [key: string]: IDocSection;
}

export interface IDocSection {
  docKey: string;
  title: string;
  documents: IUploadedDocument[];
}

export interface IUploadedDocument {
  uuid: string;
  docKey: string;
  file: File | string | null;
  metadata: IFilingDocument;
  errorMsg?: string;
}

export interface IFilingDocument {
  key: string;
  docKey: string;
  name: string;
  fileName: string;
}

export interface IFilingDeleteDoc {
  uuids: [string | null];
}

export interface IForm16Doc {
  id: string;
  uuid: string;
  fileDispalyName: string;
  fileNameHash: string;
  file: File | string | null;
}

export interface ICreateFiling {
  efilingUuid: string;
  metadata: IFilingDocument;
}

// create efiling msg
export interface ICreateEFilingMsg {
  efilingUuid: string;
  type: string;
  message: {
    text: string;
  };
}

// get efiling messages
export interface IEfilingMessage {
  id: string;
  uuid: string;
  type: string;
  message: {
    text: string;
  };
  readedAt: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  userUuid: string;
  efilingUuid: string;
  updatedBy: string;
  efilingMessageCreatedBy: {
    fullName: string;
    role: string;
  };
}

export interface ITRFilingParams {
  search?: string;
  offset?: number;
  count?: number;
  orderBy?: string | undefined;
  order?: string | undefined; // TODO: fix it to "ASC" or "DESC"
  userUuid?: string;
  authorized?: boolean;
}

export interface ITransactionRoot {
  records: IEfilingPlan[];
}

// used to create a efiling plan (On buy btn click in price card)
export interface ICreateEFilingPlanRes {
  subtotal: number;
  discount: number;
}

export interface IEfilingPlan {
  id: number;
  uuid: string;
  planData: IPlanData;
  subType: string;
  inactive: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  efilingUuid: string;
  efilingPlanTransaction: IEfilingPlanTxnResponse;
}

export interface ICreateEFPlanTxn {
  efilingUuid: string;
  planUuid: string;
  couponCode?: string | null;
}

export interface IVerifyCoupon {
  efilingUuid: string;
  planUuid: string;
  couponCode: string;
}

export interface IVerifyCodeResp {
  subtotal: number;
  total: number;
  discount: number;
}

export interface IPlanData {
  id: number;
  slug: string;
  type: string;
  uuid: string;
  title: string;
  featured: boolean;
  inactive: boolean;
  subTitle: string;
  createdAt: string;
  deletedAt: any;
  updatedAt: string;
  updatedBy: string;
  Description: string;
  payableAmount: number;
  pricingRule: ITxnPricingRule[];
  publishedAt: string;
  pricingTitle: string;
  footerContent: string;
  incomeSources: ITxnIncomeSource[];
  pricingSubTitle: string;
  subtotal: string;
}

export interface ITxnPricingRule {
  pricePerFile: number;
  minFilesCompleted: number;
}

export interface ITxnIncomeSource {
  id: string;
  value: string;
}

// used for login with token
export interface IPlanCheckoutForm {
  coupon: string;
}

// used to create txn after creating a filing plan (run just after buy efiling plan)
// response data is used in razorpay for payment
export interface IEfilingPlanTxnResponse {
  id: number;
  uuid: string;
  subtotal: string;
  discount: string;
  total: string;
  provider: string;
  orderId: string;
  orderStatus: string;
  orderData: IOrderData;
  paymentId: string;
  paymentStatus: string;
  paymentData: any;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  efilingPlanUuid: string;
}

export interface IOrderData {
  id: string;
  notes: any[];
  amount: number;
  entity: string;
  status: string;
  receipt: any;
  attempts: number;
  currency: string;
  offer_id: any;
  amount_due: number;
  created_at: number;
  amount_paid: number;
}

export interface IMsgParams {
  offset?: number;
  count?: number;
  orderBy?: string | undefined;
  efilingUuid?: string;
}

export interface IDocParams {
  offset?: number;
  count?: number;
  efilingUuid?: string;
}

export interface ITransactionListResponse {
  count: number;
  records: IEfilingPlanTxnResponse[];
}

export interface ITrackEFilingStatus {
  label: string;
  variant: string;
  bgTextColor: string;
}
